module.exports = __webpack_public_path__ + "img/2023-04-25 21.30.12.47a28da8.jpg";